import {mapGetters, mapActions} from 'vuex'
import $ from 'jquery'
import {isWixin, loginInfo, customerInfo} from 'common/js/loginInfo'
import {getQueryParams} from 'common/js/tools'
import store from '../../store'


export const timer = {
    data() {
        return {
            TIMER: {}
        }
    },
    methods: {
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {
        loading: function(newer) {
            clearTimeout(this.TIMER)
            let _this = this
            if (newer) {
                this.TIMER = setTimeout(function() {
                    _this.setLoading(false)
                    _this.$toast.fail('请求超时')
                }, 15000)
            } else {
                clearTimeout(this.TIMER)
            }
        }
    },
    computed: {
        ...mapGetters([
            'loading'
        ])
    }
}
export const wxLogin = {
    data() {
        return {
            redirect: ''
        }
    },
    created() {
        console.log("created")
        this.judgeClientType()
        // this.init()

        //20211208 问卷调查不用自动登录，解决ios下授权登录问题
        // if (this.$route.name!=='MLogin' ||
        //     (window.__wxjs_is_wkwebview && !this.$route.name && this.$route.name!=='Questionnaire' )){
        //     //排除登录页 iOS下的问卷页面            
        //     this.init()
        // }
    },
    mounted() {
        // this.init()
    },
    activated() {
        // this.init()
    },
    beforeRouteEnter(to, from , next) {
        //main.js已经处理了token的信息，只需要处理微信的处理

        // next()
        //todo 20211211 修改 根据实际情况进行拦截，否则会执行页面上的方法，造成2次刷新页面
        let user = $.extend({}, store.state.user)
        if (!to.query.token && !user.loginToken) {
            //如果参数和缓存都没有数据
            if(isWixin() && to.name!=='MLogin' && to.name !== 'DynamicStateDetails'){
                //微信浏览器，自动授权，失败了就自动转到to页面
                loginInfo(function(){
                    next()
                })
            }
            else{
                //非微信端，转到to页面
                next()
            }
        }
        else {
            next()
        }
    },
    methods: {
        judgeClientType() {
            if (isWixin()) {
                this.setClientType(3)
            } else {
                this.setClientType(2)
            }
        },
        init_Old() {
            let user = $.extend(true, {}, this.user)
            if (!this.$route.query.token && !this.user.loginToken && this.ClientType === 3) {
                this._getWXLoginInfo()
            } else if (!this.user.loginToken && this.ClientType === 3) {
                user.loginToken = this.$route.query.token
                this.setUser(user)
                sessionStorage.setItem('user', JSON.stringify(user))
            }
            if (this.user.loginToken && this.ClientType === 3 && !this.user.isperfect) {
                this.setParams()
                this._getCustomerInfo()
            } else {
                this.setParams()
            }
        },
        init() {
            // console.log("mixin 1")
            // console.log('location ',window.location)
            let user = $.extend(true, {}, this.user)
            //微信下处理
            if(this.ClientType === 3){
                if (!this.$route.query.token && !this.user.loginToken) {
                    this._getWXLoginInfo()
                }
                else if (!this.user.loginToken) {
                    user.loginToken = this.$route.query.token
                    this.setUser(user)
                    sessionStorage.setItem('user', JSON.stringify(user))
                }
                else if (!this.user.isperfect) {
                    this.setParams()
                    this._getCustomerInfo()
                }
                else{
                    this.setParams()
                }
            }
            else{
                this.setParams()
            }
        },
        setParams() {
            let path = window.location.pathname
            let params = getQueryParams()
            delete params.token
            delete params.expiretime
            this.$router.push({path: `${path}`, query: params})
        },
        _getWXLoginInfo() {
            loginInfo()
        },
        _getCustomerInfo() {
            customerInfo(this.user)
        },
        ...mapActions([
            'setUser', 'setClientType'
        ])
    },
    watch: {
    },
    computed: {
        ...mapGetters([
            'user',
            'isInit',
            'ClientType'
        ])
    }
}
export const listScrollHeight = {
    data() {
        return {}
    },
    mounted() {
        this.$nextTick(() => {
            $('.list').css({minHeight: $('.content').height() + 'px'})
        })
    },
    methods: {},
    watch: {},
    computed: {}
}

export const getShareUrl = {
    data() {
        return {}
    },
    mounted() {
    },
    beforeRouteEnter(to, from, next) {
        var userAgent = navigator.userAgent
        let path = from.path !== '/' ? from.path : to.path
        if ((userAgent.includes('iPhone') || userAgent.includes('iPad')) && !userAgent.includes('wechatdevtools')) {
            sessionStorage.setItem('prevurl', path)
            next()
        } else {
            next()
        }
        next()
    },
    methods: {},
    watch: {},
    computed: {}
}
